var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { WORKSPACE_EVENT_RESET, WORKSPACE_EVENT_SET_USER_EVENT_ROLES, WORKSPACE_EVENT_SET_EVENT, WORKSPACE_EVENT_SET_CATEGORIES, WORKSPACE_EVENT_SET_ROUNDS, WORKSPACE_EVENT_SET_ROUND_BIBS, WORKSPACE_EVENT_SET_ROUTES, WORKSPACE_EVENT_SET_TEAMS, WORKSPACE_EVENT_SET_TEAM_SCORES, WORKSPACE_EVENT_SET_ATHLETES, WORKSPACE_EVENT_SET_ATHLETE_SCORES, WORKSPACE_EVENT_SET_ATHLETE_SCORE_ROUTES, WORKSPACE_EVENT_SET_ACTIVES, WORKSPACE_EVENT_SET_NOTIFICATIONS, } from './actions';
var initialState = {
    event: undefined,
    categories: undefined,
    rounds: undefined,
    routes: undefined,
};
export var workspaceEventReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case WORKSPACE_EVENT_RESET:
            return initialState;
        case WORKSPACE_EVENT_SET_USER_EVENT_ROLES:
            return __assign({}, state, { userEventRoles: action.payload.userEventRoles });
        case WORKSPACE_EVENT_SET_EVENT:
            return __assign({}, state, { event: action.payload.event });
        case WORKSPACE_EVENT_SET_CATEGORIES:
            return __assign({}, state, { categories: action.payload.categories });
        case WORKSPACE_EVENT_SET_ROUNDS:
            return __assign({}, state, { rounds: action.payload.rounds });
        case WORKSPACE_EVENT_SET_ROUND_BIBS:
            return __assign({}, state, { roundBibs: action.payload.roundBibs });
        case WORKSPACE_EVENT_SET_ROUTES:
            return __assign({}, state, { routes: action.payload.routes });
        case WORKSPACE_EVENT_SET_TEAMS:
            return __assign({}, state, { teams: action.payload.teams });
        case WORKSPACE_EVENT_SET_TEAM_SCORES:
            return __assign({}, state, { teamScores: action.payload.teamScores });
        case WORKSPACE_EVENT_SET_ATHLETES:
            return __assign({}, state, { athletes: action.payload.athletes });
        case WORKSPACE_EVENT_SET_ATHLETE_SCORES:
            return __assign({}, state, { athleteScores: action.payload.athleteScores });
        case WORKSPACE_EVENT_SET_ATHLETE_SCORE_ROUTES:
            return __assign({}, state, { athleteScoreRoutes: action.payload.athleteScoreRoutes });
        case WORKSPACE_EVENT_SET_ACTIVES:
            return __assign({}, state, { actives: action.payload.actives });
        case WORKSPACE_EVENT_SET_NOTIFICATIONS:
            return __assign({}, state, { notifications: action.payload.notifications });
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/reducers/workspaceEvent/reducer.ts
// module id = 602
// module chunks = 0